
import {groupNameRules} from "@/data/rules/GroupRules";
import Vue from "vue";
import {TranslationItem} from "@/data/models/types/TranslationTypes";
import Group from "@/data/models/api/Group";

export default Vue.extend({
  name: "template-group-header",
  props: {
    headers: {},
    groupId: Number,
    items: Array,
    isOpen: Boolean,
    toggle: Function
  },
  data() {
    return {
      isActive: false,
      updateName: "",
      groupNameRules: groupNameRules()
    };
  },
  computed: {
    currGroup(): Group {
      return (this.items as TranslationItem[])[0].group;
    }
  },
  watch: {
    currGroup: {
      immediate: true,
      handler: function () {
        this.updateName = this.currGroup.name;
      }
    }
  },
  methods: {
    canUpdateGroup() {
      if(!this.currGroup.isDefault) this.isActive = this.$store.getters.appUser.roleAbility ? this.$store.getters.appUser.roleAbility.canWriteGroup : false;
    },
    updateGroup() {
      this.currGroup.name = this.updateName;

      this.items.forEach((item) => (item as TranslationItem).group.name = this.currGroup.name);
      this.isActive = false;
    },
    cancelUpdates() {
      this.isActive = false;
      this.updateName = this.currGroup.name;
    },
    saveGroup() {
      this.$service.groups.updateGroup(this.groupId, this.updateName)
          .then(() => this.updateGroup())
          .catch((error) => this.$notify(this.$t(error).toString(), {color: "red"}));
    }
  }
});
